<template>
	<div>
		<div class="title">
			<h1>{{dataFromServer.title}}</h1>
			<p>{{dataFromServer.createTime}}</p>
		</div>
		<div class="content">
			<ul>
				<li v-for="(item,index) in dataFromServer.wrongList">
					<p>第{{index+1}}题</p>
					<img :src="alias+item.titleImg" alt="">

				</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	props:['params','close'],
	data(){
		return {
			submitData:{},
			alias:WEBCONFIG.alioss,
			dataFromServer:{
				title:'',
				createTime:'',
				wrongList:[]
			}
		};
	},
	mounted() {
		console.log(this.params.data.id)
		this.$axios.post('/admin/paper/info/'+this.params.data.id,{},{urlencode:true}).then(data=>{
			this.dataFromServer = data
		}).end();
	},
	methods:{
		submit(){
			this.$axios.request({url:'/admin/paper/option',data:this.submitData,method:this.params.type})
			.then(data=>{
				this.close();
			}).end();
		},
	},
}
</script>

<style scoped lang="scss">
	.title{
		text-align: center;
	}
	.content{
		text-align: center;
		li{
			list-style: none;
			p{
				text-align: left;
				font-weight: 600;
			}
		}
		img{
			max-width:60%;
		}
	}
</style>
